module.exports = __webpack_public_path__ + "images/emoji/a.cd8ab6ea066363baf62e.png";